import { render, staticRenderFns } from "./BespokeMarketingPage.vue?vue&type=template&id=c4d88490&"
import script from "./BespokeMarketingPage.vue?vue&type=script&lang=js&"
export * from "./BespokeMarketingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports